import {App2} from "./App2";
import React from "react";
import {useAuth0} from "@auth0/auth0-react";

export const ErrorNotWhitelisted = () => {

  const {logout} = useAuth0();

  const auth0Logout = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  }

  return <App2>
    <div style={{margin: 100}}>
      <h2>We're sorry but it appears you don't have early access.</h2>

      <div style={{marginBottom: 50}}>
        If you chose the wrong login, log out and continue with the correct one.
      </div>

      <div>
        <button className={'ActionButton'} onClick={auth0Logout}>Log out</button>
      </div>
    </div>
  </App2>
}